import React from 'react';
import './Header.scss';
import { Nav, Navbar } from 'react-bootstrap';

function Header() {
  return (
    <Navbar bg="info" expand="lg">
      <Navbar.Brand href="/">LabelBox</Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav" className="justify-content-right">
        <Nav.Link href="/">Home</Nav.Link>
        <Nav.Link href="/paperJs">Paper.js</Nav.Link>
        <Nav.Link href="/fabricJs">Fabric.js</Nav.Link>
      </Navbar.Collapse>
    </Navbar>
  )
};

export default Header;
